<template>
  <div id="app">
    <link href="https://cdn.jsdelivr.net/npm/animate.css@3.5.1" rel="stylesheet" type="text/css">
    <nav class="navbar navbar-default navbar-fixed-top" :class="navBarFont">
      <div class="container-fluid">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#menu">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="http://shesaidyesto.me">
            <img src="./assets/characters_long.png" alt="SheSaidYesToMe">
          </a>
          <ul class="nav pull-right visible-xs-block">
            <li class="pull-left" v-if="!authenticated">
              <p class="navbar-btn">
                <a
                  href="#"
                  role="button"
                  class="btn btn-primary"
                  @click="auth.login()"
                >
                  {{ $t("app.login") }}
                </a>
              </p>
            </li>
            <li class="pull-left" v-if="authenticated">
              <p class="navbar-btn">
                <a
                  href="#"
                  role="button"
                  class="btn btn-primary"
                  @click="auth.logout()"
                >
                  {{ $t("app.logout") }}
                </a>
              </p>
            </li>
            <li class="pull-left">
              <a href="#" @click="setLanguage('fr')" class="lang-icon">
                <img src="./assets/france-flag-256.png" alt="Flag of France" />
              </a>
            </li>
            <li class="pull-right">
              <a href="#"  @click="setLanguage('ge')" class="lang-icon">
                <div class="img-icon">
                  <img src="./assets/georgia-flag-256.png" alt="Flag of Georgia" />
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div class="navbar-header pull-right hidden-xs">
          <ul class="nav pull-left">
            <li class="pull-left" v-if="!authenticated">
              <p class="navbar-btn">
                <a
                  href="#"
                  role="button"
                  class="btn btn-primary"
                  @click="auth.login()"
                >
                  {{ $t("app.login") }}
                </a>
              </p>
            </li>
            <li class="pull-left" v-if="authenticated">
              <p class="navbar-btn">
                <a
                  href="#"
                  role="button"
                  class="btn btn-primary"
                  @click="auth.logout()"
                >
                  {{ $t("app.logout") }}
                </a>
              </p>
            </li>
            <li class="pull-left">
              <a href="#" @click="setLanguage('fr')" class="lang-icon">
                <img src="./assets/france-flag-256.png" alt="Flag of France" />
              </a>
            </li>
            <li class="pull-right">
              <a href="#"  @click="setLanguage('ge')" class="lang-icon">
                <div class="img-icon">
                  <img src="./assets/georgia-flag-256.png" alt="Flag of Georgia" />
                </div>
              </a>
            </li>
          </ul>
        </div>
        <!-- Collect the nav links, forms, and other content for toggling -->
        <div id="menu" class="collapse navbar-collapse">
          <ul class="nav navbar-nav">
            <router-link to="/Us" active-class="active" tag="li">
              <a>
                {{ $t("app.us") }}
              </a>
            </router-link>
            <router-link to="/Gallery" active-class="active" tag="li">
              <a>
                {{ $t("app.gallery") }}
              </a>
            </router-link>
            <router-link to="Groom" active-class="active" tag="li">
              <a>
                {{ $t("app.groom") }}
              </a>
            </router-link>
            <router-link to="Ceremony" active-class="active" tag="li">
              <a>
                {{ $t("app.ceremony") }}
              </a>
            </router-link>
            <router-link to="Uin" active-class="active" tag="li">
              <a>
                {{ $t("app.uin") }}
              </a>
            </router-link>
            <router-link v-if="isLangGeo" to="Gifts" active-class="active" tag="li">
              <a>
                {{ $t("app.gifts") }}
              </a>
            </router-link>
          </ul>
        </div><!-- /.navbar-collapse -->
      </div><!-- /.container-fluid -->
    </nav>

    <!-- <transition
      name="fade"
    > -->
    <div :class="mainFont" class="spaces">
      <Left class="content col-md-2"></Left>
      <router-view
        class="content container col-md-8"
        :auth="auth"
        :authenticated="authenticated">
      </router-view>
      <Right class="content col-md-2"></Right>
    </div>

    <!-- </transition> -->
  </div>
</template>

<script>
import Left from '@/components/Left'
import Right from '@/components/Right'
import AuthService from '@/auth/AuthService'

const auth = new AuthService()

const { login, logout, authenticated, authNotifier } = auth

export default {
  name: 'App',
  data () {
    authNotifier.on('authChange', authState => {
      this.authenticated = authState.authenticated
    })
    return {
      auth,
      authenticated
    }
  },
  methods: {
    login,
    logout,
    setLanguage: function (lang) {
      this.$i18n.locale = lang
    }
  },
  computed: {
    navBarFont: function () {
      return {
        'font-rayuela': this.$i18n.locale === 'ge',
        'font-moon-flower': this.$i18n.locale === 'fr'
      }
    },
    mainFont: function () { // TODO: Define fonts
      return {
        'text-ge': this.$i18n.locale === 'ge',
        'text-fr': this.$i18n.locale === 'fr'
      }
    },
    isLangGeo: function () {
      return this.$i18n.locale === 'ge'
    }
  },
  mounted: function () {
    // console.log(auth)
    // console.log(authenticated)
    var menu = document.getElementById('menu')
    var items = menu.querySelectorAll('.nav li')
    for (let i = 0; i < items.length; ++i) {
      items[i].addEventListener('click', function () {
        menu.classList.remove('in')
      })
    }
  },
  components: { Left, Right }
}

</script>

<style lang="scss">
$icon-font-path: '../static/fonts/bootstrap/';
@import './styles/custom.scss';
@import './styles/index.scss';

body {
  background-color: #f2f2f2;
}

.fade-enter-active {
  // transition: opacity .5s;
  // transition: all .3s cubic-bezier(0.65, 0.05, 0.36, 1);
  transition: all 3s ease-in;
}

.fade-leave-active {
  transition: all 3s ease-out;
}

.fade-leave {
    transform: translateY(-100%);
}

.fade-enter {
  transform: translateY(100%);
}

.spaces {
  padding-top: 70px;
  margin-bottom: 50px;
}

.lang-icon img {
  width: 2.1rem;
}

.navbar-brand {
  padding: 0px;
}

.navbar-brand > img {
  height: 100%;
  padding: 0 15px 0 15px;
  width: auto;
}

.font-moon-flower {
  font-family: 'Moon Flower';
  font-weight: 500;
  font-size: 20px !important;
  letter-spacing: 1px;
}

.font-rayuela {
  font-family: 'Rayuela';
  font-weight: 500;
  font-size: 18px !important;
  letter-spacing: 3px;
}

%fixed-auto {
  position: fixed;
  z-index: -1;
  width: auto;
  height: auto;
}

.text-ge {
  font-family: 'Saba';
}

.text-fr {
  font-family: 'Dancing Script';
}

%top70 {
  top: 70px;
}

%bottom0 {
    bottom: 0;
}

%right0 {
  right: 0;
}

#menu {
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/App.vue